import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
@Component({
    selector: 'ef-invoice-register-filters-presenter',
    templateUrl: './invoice-register-filters-presenter.component.html',
    styleUrls: ['./invoice-register-filters-presenter.component.scss'],
    standalone: false
})
export class InvoiceRegisterFiltersPresenterComponent
    implements OnInit, OnDestroy, OnChanges {
    @Input() StartDate: Date;
    @Input() EndDate: Date;
    @Input() Contracts: SelectItem[];
    @Output() SelectStartDate = new ReplaySubject<Date>(1);
    @Output() SelectEndDate = new ReplaySubject<Date>(1);
    @Output() SelectContracts = new ReplaySubject<string[]>(1);
    @Output() FilterInvoiceNumber = new ReplaySubject<string>(1);
    filterFormGroup: UntypedFormGroup;
    moment: any;
    private active = true;
    constructor(private log: LoggingService) {
        this.filterFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(),
            endDate: new UntypedFormControl(),
            contracts: new UntypedFormControl(),
            invoiceNumber: new UntypedFormControl()
        });
        this.moment = moment;
    }
    ngOnChanges(changes: SimpleChanges) {
        setTimeout(() => {
            if (changes.StartDate) {
                this.filterFormGroup.controls['startDate'].setValue(
                    changes.StartDate.currentValue
                );
            }
            if (changes.EndDate) {
                this.filterFormGroup.controls['endDate'].setValue(
                    changes.EndDate.currentValue
                );
            }
        }, 0);
    }
    ngOnInit(): void {
        const controls = this.filterFormGroup.controls;
        controls['startDate'].valueChanges
            .pipe(
                takeWhile(() => this.active),
                tap(startDate =>
                    this.log.verbose({
                        type: 'InvoiceRegisterFiltersPresenterComponent:startDate',
                        startDate
                    })
                )
            )
            .subscribe(value => this.SelectStartDate.next(value));
        controls['endDate'].valueChanges
            .pipe(
                takeWhile(() => this.active),
                tap(endDate =>
                    this.log.verbose({
                        type: 'InvoiceRegisterFiltersPresenterComponent:endDate',
                        endDate
                    })
                )
            )
            .subscribe(value => this.SelectEndDate.next(value));
        controls['contracts'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => this.SelectContracts.next(value));
        controls['invoiceNumber'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => this.FilterInvoiceNumber.next(value));
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
